import {Loc} from 'landing.loc';

export const EtLineIcons = {
	id: 'et_line_icon',
	name: '100 Line Icons',
	active: true,
	categories: [
		{
			id: 'et_line_icon_all',
			name: Loc.getMessage('LANDING_ICONS_SIMPLE_LINE_ICONS_ALL'),
			items: [
				'et-icon-mobile',
				'et-icon-laptop',
				'et-icon-desktop',
				'et-icon-tablet',
				'et-icon-phone',
				'et-icon-document',
				'et-icon-documents',
				'et-icon-search',
				'et-icon-clipboard',
				'et-icon-newspaper',
				'et-icon-notebook',
				'et-icon-book-open',
				'et-icon-browser',
				'et-icon-calendar',
				'et-icon-presentation',
				'et-icon-picture',
				'et-icon-pictures',
				'et-icon-video',
				'et-icon-camera',
				'et-icon-printer',
				'et-icon-toolbox',
				'et-icon-briefcase',
				'et-icon-wallet',
				'et-icon-gift',
				'et-icon-bargraph',
				'et-icon-grid',
				'et-icon-expand',
				'et-icon-focus',
				'et-icon-edit',
				'et-icon-adjustments',
				'et-icon-ribbon',
				'et-icon-hourglass',
				'et-icon-lock',
				'et-icon-megaphone',
				'et-icon-shield',
				'et-icon-trophy',
				'et-icon-flag',
				'et-icon-map',
				'et-icon-puzzle',
				'et-icon-basket',
				'et-icon-envelope',
				'et-icon-streetsign',
				'et-icon-telescope',
				'et-icon-gears',
				'et-icon-key',
				'et-icon-paperclip',
				'et-icon-attachment',
				'et-icon-pricetags',
				'et-icon-lightbulb',
				'et-icon-layers',
				'et-icon-pencil',
				'et-icon-tools',
				'et-icon-tools-2',
				'et-icon-scissors',
				'et-icon-paintbrush',
				'et-icon-magnifying-glass',
				'et-icon-circle-compass',
				'et-icon-linegraph',
				'et-icon-mic',
				'et-icon-strategy',
				'et-icon-beaker',
				'et-icon-caution',
				'et-icon-recycle',
				'et-icon-anchor',
				'et-icon-profile-male',
				'et-icon-profile-female',
				'et-icon-bike',
				'et-icon-wine',
				'et-icon-hotairballoon',
				'et-icon-globe',
				'et-icon-genius',
				'et-icon-map-pin',
				'et-icon-dial',
				'et-icon-chat',
				'et-icon-heart',
				'et-icon-cloud',
				'et-icon-upload',
				'et-icon-download',
				'et-icon-target',
				'et-icon-hazardous',
				'et-icon-piechart',
				'et-icon-speedometer',
				'et-icon-global',
				'et-icon-compass',
				'et-icon-lifesaver',
				'et-icon-clock',
				'et-icon-aperture',
				'et-icon-quote',
				'et-icon-scope',
				'et-icon-alarmclock',
				'et-icon-refresh',
				'et-icon-happy',
				'et-icon-sad',
				'et-icon-facebook',
				'et-icon-twitter',
				'et-icon-googleplus',
				'et-icon-rss',
				'et-icon-tumblr',
				'et-icon-linkedin',
				'et-icon-dribbble',
			],
		},
	],
};